// extracted by mini-css-extract-plugin
export default {"PlantGrassSection-container":"index_PlantGrassSection-container__mQnkp"};